import type { StateService, UIRouterGlobals } from "@uirouter/angularjs";
import type { IScope } from "angular";
import { isEmpty } from "lodash";
import { finalize } from "rxjs/operators";

import type { IAccountRepository, IPasswordResetObject } from "App/Modules/Auth";
import type { IResponseWithLoading } from "App/Modules/Models";
import { extendWithLoadingAndFail } from "../../../../Services/ObservableExtensions";

export class ConfirmPasswordResetComponentController {
    public static $inject: string[] = ["$scope", "$state", "$uiRouterGlobals", "mmAccountRepository"];

    public passwordResetObject: IPasswordResetObject;

    public confirmPasswordResetResponse: IResponseWithLoading<void>;

    constructor(
        private readonly $scope: IScope,
        private readonly $state: StateService,
        private readonly $uiRouterGlobals: UIRouterGlobals,
        private readonly accountRepository: IAccountRepository,
    ) {}

    public $onInit() {
        this.passwordResetObject = {
            newPassword: null,
            passwordResetKey: this.$uiRouterGlobals.params.passwordResetKey,
        };
    }

    public confirmPasswordReset() {
        if (!isEmpty(this.passwordResetObject)) {
            extendWithLoadingAndFail(this.accountRepository.confirmPasswordReset(this.passwordResetObject))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<void>) => {
                        this.confirmPasswordResetResponse = response;
                        if (!response.hasError && !response.isLoading) {
                            this.$state.go("login");
                        }
                    },
                    (error) => {
                        this.confirmPasswordResetResponse = error;
                    },
                );
        }
    }
}
